import React from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { Spinner } from '@vp/swan';
import { currentCulture } from 'src/utils/cultureUtil';
import { text } from 'src/utils/localizationUtil';

const ListPrice = styled.span`
  text-decoration: line-through;
  opacity: 0.75;
`;

export interface Price {
  listPrice: number;
  discountedPrice: number;
  currency: string;
}

export type PriceDisplayProps = {
  price: Price;
  priceIsLoaded: boolean;
  multiLine?: boolean;
};

function formatIndividualPrice(price: number, currency: string) {
  return new Intl.NumberFormat(currentCulture, {
    currency,
    currencyDisplay: 'narrowSymbol',
    style: 'currency',
  }).format(price);
}

export function formatPrice({ discountedPrice, currency }: Price) {
  return formatIndividualPrice(discountedPrice, currency);
}

// This avoids uses children because that breaks the Trans component
export const PriceDisplay = ({ price, priceIsLoaded, multiLine }: PriceDisplayProps) =>
  priceIsLoaded ? (
    <ActualPrice multiLine={multiLine}>{price}</ActualPrice>
  ) : (
    <Spinner accessibleText={text('loading')} />
  );

const ActualPrice = ({ multiLine, children }: { multiLine: boolean | undefined; children?: Price }) =>
  children ? (
    <span
      style={{
        width: 'max-content',
        textAlign: 'center',
        display: 'inline-block',
      }}
    >
      {children.listPrice !== children.discountedPrice && (
        <>
          <ListPrice>&nbsp;{formatIndividualPrice(children.listPrice, children.currency)}&nbsp;</ListPrice>
          {multiLine ? <br /> : <>&nbsp;</>}
        </>
      )}
      {formatIndividualPrice(children.discountedPrice, children.currency)}
    </span>
  ) : (
    <Trans i18nKey="free" />
  );
